
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11787',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11787",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.454",
  "dashboard-client-types": "static-1.290",
  "data-fetching-client": "static-1.9548",
  "foundations-components": "static-1.7655",
  "foundations-components-legacy": "static-1.680",
  "foundations-theming": "static-1.4281",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.79",
  "head-dlb": "static-1.4884",
  "hs-test-utils": "static-1.7882",
  "hub-http-shared-msw-handlers": "static-1.9647",
  "hubspot-dlb": "static-2.1806",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11314",
  "I18n": "static-7.1597",
  "jasmine-runner": "static-1.6341",
  "marketplace-storefront-base": "static-1.11848",
  "quartz": "static-1.6827",
  "react-dlb": "static-1.74",
  "react-rhumb": "static-1.16522",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2734",
  "reporting-testing-lib": "static-1.8760",
  "settings-ui-lib": "static-1.12394",
  "SharedI18nStrings": "static-1.181",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6875",
  "ui-addon-i18n": "static-1.11017",
  "ui-addon-react-router-dom": "static-1.9416",
  "unified-auth": "static-1.307",
  "unified-auth-core-lib": "static-1.588",
  "usage-tracker": "static-1.7207",
  "usage-tracker-core": "static-1.7057",
  "customer-data-property-utils": "static-1.7952",
  "history": "static-4.47",
  "hub-http": "static-1.6090",
  "integrations-lib": "static-1.15643",
  "marketplace-ui-common": "static-1.19162",
  "property-management-iframe": "static-1.12654",
  "quartz-config": "static-1.605",
  "quartz-core": "static-1.6046",
  "quartz-routing": "static-1.257",
  "quick-fetch": "static-1.3805",
  "react": "static-7.182",
  "rpc-client-utils": "static-1.4515",
  "ts-schema": "static-1.3972",
  "ui-universal-auth": "static-1.8793",
  "UIComponents": "static-3.8261",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.416",
  "hs-promise-rejection-tracking": "static-1.5433",
  "PortalIdParser": "static-2.377",
  "raven": "static-3.5768",
  "raven-hubspot": "static-1.6075",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3297",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3104",
  "quartz-webpack": "static-1.3051",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3924",
  "floating-ui": "static-1.53",
  "foundations-assets": "static-1.4711",
  "foundations-theming-specialty": "static-1.1997",
  "framer-motion": "static-1.69",
  "hs-story-utils": "static-1.9298",
  "react-aria": "static-1.63",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5240",
  "react-virtualized": "static-2.96",
  "StyleGuideUI": "static-3.485",
  "tanstack-table": "static-1.52",
  "trellis-assets": "static-1.1412",
  "ui-fonts": "static-1.576",
  "ui-images": "static-2.1122",
  "bend-plugin-foundations-theming": "static-1.2764",
  "foundations-theming-base": "static-1.3266",
  "stylex": "static-1.29",
  "HeadJS": "static-2.731",
  "hs-test-utils-bend-plugin": "static-1.2993",
  "msw": "static-1.39",
  "testing-library": "static-1.149",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.218",
  "moment-timezone": "static-5.80",
  "jasmine": "static-4.4197",
  "ai-components-ui-library": "static-1.8565",
  "ai-rendering-library": "static-1.9548",
  "chirp-fetch": "static-1.1753",
  "connections-embed-lib": "static-1.734",
  "copilot-toolkit": "static-1.10727",
  "laboratory-lib": "static-3.7031",
  "marketplace-embed": "static-1.21663",
  "marketplace-ui-details": "static-1.9058",
  "marketplace-ui-reviews": "static-1.19118",
  "marketplace-ui-tracking": "static-1.13333",
  "sanitize-text": "static-1.8016",
  "ui-addon-video-player": "static-1.8567",
  "usage-tracker-multi": "static-1.5621",
  "usage-tracker-session-replay": "static-1.4893",
  "wootric-nps": "static-1.6854",
  "apollo-link-hub-http": "static-2.4522",
  "immer": "static-1.33",
  "immerable": "static-1.4025",
  "highcharts": "static-8.101",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2413",
  "reporting-data": "static-1.66827",
  "cssUtils": "static-1.762",
  "flux-actions": "static-1.323",
  "HubStyle": "static-2.11622",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10082",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10245",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7197",
  "icons": "static-2.636",
  "marketplace-ui-apps-core": "static-1.17695",
  "storybook-react": "static-1.30",
  "trellis-story-utils": "static-1.4391",
  "foundations-components-test-utils": "static-1.5138",
  "quartz-i18n": "static-1.502",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3602",
  "customer-data-objects": "static-1.7525",
  "property-translator": "static-1.5279",
  "frontend-preferences-client": "static-1.7795",
  "hs-promise-utils": "static-1.5466",
  "hubspot-apollo-client": "static-1.4750",
  "integrations-error-boundary-lib": "static-1.13058",
  "integrations-tracking-lib": "static-1.5462",
  "native-integrations-shared-strings": "static-1.7658",
  "reselect": "static-2.16",
  "sanitize": "static-1.4345",
  "superstore": "static-1.4640",
  "ui-shepherd-react": "static-3.10017",
  "ai-settings-ui-library": "static-1.7663",
  "hub-http-janus": "static-1.815",
  "hubspotter-http": "static-1.4545",
  "immutable-less": "static-1.4524",
  "marketplace-ui-client-types": "static-1.16569",
  "nav-meta": "static-1.29153",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10113",
  "ui-addon-upgrades": "static-9.17768",
  "inbound-db-properties-service-client": "static-1.3738",
  "property-management-common": "static-1.4942",
  "ui-addon-iframeable": "static-1.8918",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.505",
  "module-federation": "static-1.20",
  "quartz-auth": "static-1.502",
  "quartz-head": "static-1.492",
  "quartz-test": "static-1.502",
  "quartz-tracking": "static-1.206",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.3025",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20638",
  "ContentUtils": "static-1.67843",
  "sassPrefix": "static-1.153",
  "avatar-components": "static-1.2364",
  "customer-data-filters-ui": "static-1.39164",
  "customer-data-objects-ui-components": "static-1.12884",
  "customer-data-reference-ui-components": "static-1.13019",
  "embedded-academy-lib": "static-1.13815",
  "ExportDialog": "static-6.10260",
  "highlight.js": "static-1.76",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40849",
  "reporting-snowflake": "static-1.55445",
  "reporting-ui-components": "static-2.64098",
  "reporting-visualizations": "static-1.58903",
  "ui-addon-teams": "static-1.21345",
  "magpie-lib": "static-1.5465",
  "magpie-types": "static-1.4925",
  "simple-logging-lib": "static-1.2921",
  "navigation-components": "static-1.17516",
  "ai-studio-lib": "static-1.11195",
  "app-governance-lib": "static-1.1100",
  "developer-experience-shared-components": "static-1.10373",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7861",
  "ui-product-approvals": "static-1.27696",
  "ui-tool-access": "static-1.10016",
  "usage-based-billing-components-lib": "static-1.8210",
  "usage-tracker-anonymous": "static-1.5624",
  "usage-tracker-public": "static-1.7018",
  "amplitude-session-replay-browser": "static-1.57",
  "inbound-db-meta-service-client": "static-1.3484",
  "persist-promise": "static-1.3580",
  "reference-resolvers": "static-1.8036",
  "ui-extensibility-client-types": "static-1.3812",
  "hubspot-apollo-cache": "static-1.209",
  "universal-page-editor-lib": "static-1.2872",
  "final-form": "static-1.67",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2377",
  "merchandise-lib": "static-1.261",
  "atom": "static-1.4941",
  "purchase-motions-components": "static-1.5605",
  "salesImages": "static-1.522",
  "batch-promise": "static-1.1423",
  "crm-component-utils": "static-1.38663",
  "crm-properties-common-lib": "static-1.5744",
  "customer-data-properties": "static-1.51016",
  "framework-data-schema-resolvers": "static-1.6745",
  "property-value-citations": "static-1.1630",
  "reference-resolvers-lite": "static-1.7956",
  "navigation-messaging": "static-1.6843",
  "hubspotter-http-shared-msw-handlers": "static-1.9645",
  "cms-field-types": "static-1.4680",
  "content-icons-ui": "static-1.2186",
  "conversations-skeleton-state": "static-1.7120",
  "crm-message-bus": "static-1.42581",
  "customer-data-filters-ui-msw-helpers": "static-1.21599",
  "customer-data-ui-utilities": "static-1.9695",
  "FormUrlGenerator": "static-2.4592",
  "framework-builder-read-service-client": "static-1.3900",
  "framework-data-schema-quick-fetch": "static-1.6650",
  "multi-account-reference-resolvers": "static-1.848",
  "onboarding-tours": "static-1.16365",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13263",
  "academy-common-lib": "static-1.13275",
  "content-assistance-lib": "static-1.7548",
  "dashboard-lib": "static-1.80924",
  "file-manager-components": "static-1.23140",
  "getting-started-shared-tasks": "static-1.18081",
  "hubspot-prosemirror": "static-1.17812",
  "hubspot-prosemirror-plugins": "static-1.17804",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19596",
  "share-with-third-party-component-lib": "static-1.8564",
  "ui-addon-draggable": "static-3.4639",
  "ui-asset-management-lib": "static-1.10813",
  "ui-business-units-lib": "static-1.8904",
  "user-context": "static-1.4971",
  "growth-payments-core": "static-1.24929",
  "reporting-plugins": "static-1.10069",
  "reporting-reports": "static-1.66505",
  "idb-keyval": "static-1.41",
  "reactive-lib": "static-1.595",
  "codemirror": "static-5.92",
  "feedback-loader": "static-1.29017",
  "react-codemirror": "static-1.10497",
  "framework-listing-lib": "static-2.28240",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30304",
  "apps-service-types": "static-1.3748",
  "oauth-service-types": "static-1.4118",
  "onboarding-scopes": "static-1.6334",
  "onboarding-tours-client": "static-1.4579",
  "platform-infra-nav-components": "static-1.7559",
  "subscription-experience-data-types": "static-1.14679",
  "crm-record-cards-service-types": "static-1.3509",
  "location-customization-utils-lib": "static-1.8784",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4370",
  "nav-client-types": "static-1.2228",
  "purchase-motions-api": "static-1.5608",
  "signup-constants": "static-1.18556",
  "signup-ui-url-generator": "static-2.7906",
  "trials-service-types": "static-1.3771",
  "card-properties-lib": "static-1.43728",
  "commerce-subscription-lib": "static-1.36664",
  "crm-actions": "static-1.6181",
  "crm-cards-sdk": "static-1.43135",
  "customer-data-properties-shared-msw-handlers": "static-1.8974",
  "customer-data-tracking": "static-1.6754",
  "hs-entities": "static-1.558",
  "pulse": "static-1.397",
  "calling-global-api": "static-1.63950",
  "calling-internal-common": "static-1.31171",
  "calling-lifecycle-internal": "static-1.65332",
  "calling-lifecycle-messages": "static-1.57626",
  "commerce-products-lib": "static-1.9042",
  "conditional-properties-service-client": "static-1.3690",
  "crm-links": "static-1.6141",
  "external-options-client-types": "static-1.4051",
  "google-libphonenumber": "static-1.35",
  "inbounddb-objects-service-types": "static-1.4115",
  "meetings-icalendar-utils-lib": "static-1.502",
  "multi-currency-client-types": "static-1.3582",
  "object-builder-ui-client": "static-1.48246",
  "pipeline-validation-client-types": "static-1.3856",
  "smart-property-lib": "static-1.6229",
  "tiered-pricing": "static-1.942",
  "ui-addon-form-validation": "static-1.10864",
  "crm-pipelines-api-client-types": "static-1.4034",
  "react-dnd-compat": "static-1.4491",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5231",
  "growth-onboarding-confetti": "static-1.2943",
  "growth-onboarding-next-action-utils": "static-1.1487",
  "onboarding-tours-utils": "static-1.431",
  "ui-shepherd-tracker": "static-1.7398",
  "academy-service-client": "static-1.3551",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.28134",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8255",
  "video-components-external": "static-1.10803",
  "video-data-lib": "static-1.34461",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8429",
  "payment-link-components": "static-1.23127",
  "ui-addon-emoji-picker": "static-1.9758",
  "EmailSignatureEditor": "static-1.24046",
  "viral-links-lib": "static-1.6911",
  "data-token-picker": "static-1.16168",
  "FileManagerLib": "static-1.38780",
  "react-flip-move": "static-1.67",
  "timezone-utils": "static-2.5115",
  "getting-started-shared-tasks-store": "static-1.17199",
  "campaign-roi-lib": "static-1.8497",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7193",
  "customer-data-views-management": "static-1.25135",
  "framework-data-table": "static-2.11593",
  "marketing-platform-lib": "static-1.6717",
  "nudge-client-utils": "static-1.2293",
  "nudge-custom-ui-functions": "static-1.796",
  "app-users-service-client": "static-1.5416",
  "app-users-service-types": "static-1.4824",
  "mini-checkout-client": "static-1.26489",
  "onboarding-utils": "static-1.5223",
  "permissions-shared-i18n-strings-fe": "static-1.1975",
  "ui-coaching-tips-shared-config": "static-1.28119",
  "edison-service-client-types": "static-1.263",
  "eligibility-engine-service-types": "static-1.3052",
  "crm_data": "static-4.91485",
  "customer-data-sidebar": "static-2.45610",
  "enrichment-properties-lib": "static-1.15347",
  "commerce-billing-lib": "static-1.18687",
  "commerce-shared-components-lib": "static-1.18147",
  "commerce-tools-ui-lib": "static-1.9986",
  "crm-fe-perf": "static-1.22775",
  "directed-graph": "static-1.810",
  "event-emitter": "static-1.818",
  "fast-json-patch": "static-1.60",
  "calling-error-reporting": "static-1.31177",
  "shared-worker-versioning": "static-1.10910",
  "calling-usage-tracker": "static-1.6412",
  "voice-sms-access-library": "static-1.455",
  "commerce-permissions": "static-1.635",
  "products-iframe-lib": "static-1.7530",
  "products-ui-components-shared-msw-handlers": "static-1.10029",
  "breeze-intelligence-kit": "static-1.5421",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9730",
  "policy-lib": "static-1.6650",
  "react-tinymce": "static-1.54824",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9793",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53950",
  "tinymce-plugins": "static-1.57064",
  "tinymce-themes": "static-1.55920",
  "growth-onboarding-next-action-components": "static-1.1515",
  "user-context-client": "static-1.4484",
  "growth-onboarding-feedback-components": "static-1.6452",
  "content-media-composition-data-lib": "static-1.11741",
  "content-media-compositions": "static-2.15748",
  "media-bridge-lib": "static-1.18690",
  "commerce-tours-lib": "static-1.5835",
  "growth-onboarding-reliability": "static-1.4957",
  "sales-checkout-service-client": "static-1.3539",
  "draft-convert": "static-2.70",
  "draft-extend": "static-3.72",
  "draft-js": "static-5.75",
  "draft-plugins": "static-2.21434",
  "sales-email-signature-service-client": "static-1.3714",
  "audio-components": "static-1.5711",
  "FileManagerCore": "static-1.38639",
  "FileManagerImages": "static-1.36291",
  "video-components": "static-1.12806",
  "crm-export-dialog": "static-1.6165",
  "crm-index-associations-lib": "static-1.6306",
  "react-beautiful-dnd": "static-1.13",
  "deal-intel-decorators": "static-1.1512",
  "tanstack-virtual": "static-1.27",
  "nudge-custom-function-registry": "static-1.2050",
  "nudge-renderer-utils": "static-1.2369",
  "whisper-core-api": "static-1.6187",
  "InboxConnectUtils": "static-4.14414",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5217",
  "settings-content-modals": "static-1.45663",
  "crm_universal": "static-1.21770",
  "customer-data-email": "static-1.17795",
  "card-payment-highlight-lib": "static-1.36715",
  "card-subscription-highlight-lib": "static-1.39087",
  "commerce-contract-lib": "static-1.11461",
  "invoices-highlight-card-lib": "static-1.54252",
  "orders-highlight-card-lib": "static-1.21057",
  "products-highlight-card-lib": "static-1.17326",
  "quotes-highlight-card-lib": "static-1.71437",
  "crm-source-interpretation-lib": "static-1.5202",
  "utility-belt": "static-1.2411",
  "payments-enrollment-embed-lib": "static-1.22213",
  "customer-data-rte": "static-1.32623",
  "cv-backend-services": "static-1.1528",
  "growth-onboarding-empty-states": "static-1.5470",
  "payments-post-enroll-local-storage-lib": "static-1.4985",
  "qrcode-generator": "static-1.66",
  "quotes-client-types": "static-1.37527",
  "calling-orchestration-schema": "static-1.35232",
  "sales-views-client-types": "static-1.4135",
  "hub-http-contrib": "static-1.2914",
  "interframe": "static-3.4633",
  "tinymce-data": "static-1.40035",
  "ui-addon-sales-email": "static-1.5084",
  "layout-dnd-components": "static-1.12181",
  "layout-dnd-utils": "static-1.11156",
  "ui-brand-identity-lib": "static-1.14408",
  "NamespacedHubStyle": "static-2.8961",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4403",
  "video-embed": "static-1.35295",
  "social-insights-client-types": "static-1.21606",
  "deal-intel-utils": "static-1.1516",
  "checkout-sdk": "static-3.23332",
  "checkout-service-types": "static-1.3718",
  "company-details-components": "static-1.6057",
  "payment-method-components": "static-1.6765",
  "pricing-pages-ui-components": "static-1.13012",
  "quote-checkout-service-types": "static-1.3355",
  "upgrade-catalog-service-types": "static-1.3397",
  "access-control-lib": "static-1.10309",
  "EmailComponents": "static-1.54341",
  "EmailData": "static-1.53018",
  "redux-less": "static-2.9357",
  "sequences-lib": "static-1.7807",
  "ui-gdpr-components": "static-1.10219",
  "products-ui-components": "static-1.39561",
  "quotes-ui-lib": "static-1.80158",
  "accounting-integrations-ui-components": "static-1.6846",
  "invoices-ui-lib": "static-1.54268",
  "commerce-products-api": "static-1.2067",
  "invoices-iframe-lib": "static-1.56326",
  "quotes-modal-lib": "static-1.102115",
  "stripe-embedded-components": "static-1.7265",
  "draft-content-plugins": "static-1.27891",
  "ContentData": "static-1.67918",
  "layout-data-lib": "static-1.9481",
  "outpost": "static-1.4069",
  "hub-http-rxjs": "static-1.781",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3800",
  "billing-payments-client-types": "static-1.3860",
  "account-and-billing-fintech-outages": "static-3.18333",
  "pricing-pages-api": "static-1.12877",
  "ContentComponents": "static-2.70799",
  "marketing-contacts-lib": "static-1.9370",
  "marketing-email-service-types": "static-1.1820",
  "messaging-editing-lib": "static-1.45824",
  "messaging-usage-based-billing-components-lib": "static-1.686",
  "automation-ui-source-apps": "static-1.18434",
  "automation-ui-types": "static-1.19352",
  "messaging-types-lib": "static-1.45561",
  "onboarding-settings-client": "static-1.4376",
  "sequences-client-types-lib": "static-1.7664",
  "commerce-tax-lib": "static-1.389",
  "property-description-translator": "static-1.3725",
  "commerce-analytics-service-client": "static-1.3527",
  "totals-ui-components": "static-1.23180",
  "stripe-connect-js": "static-1.65",
  "advanced-menus-core": "static-1.14917",
  "advanced-menus-lib": "static-1.11885",
  "ui-memberships-settings-lib": "static-1.33643",
  "demographics-service-types": "static-1.1520",
  "automation-ui-ubb": "static-1.5268",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7211",
  "data-token-views": "static-1.16149",
  "forms-utils-lib": "static-1.12311",
  "payments-embed-points-lib": "static-1.12749",
  "simple-menus-core": "static-1.14916",
  "simple-menus-lib": "static-1.16433",
  "ui-addon-draggable-compat": "static-2.4125",
  "videoconference-integration-components": "static-1.6628",
  "automation-applications-service-types": "static-1.3399",
  "automation-platform-service-types": "static-1.2544",
  "ContentEditorUI": "static-2.76730",
  "short-messages-app-service-client": "static-1.3867",
  "web-interactives-components": "static-1.13525",
  "web-interactives-data": "static-1.13526",
  "messaging-shared-utils-lib": "static-1.135",
  "messaging-user-info-utils-lib": "static-1.305",
  "email-portal-health-service-types": "static-1.847",
  "commerce-totals-service-types": "static-1.3708",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21288",
  "automation-ui-usage-tracking": "static-1.20751",
  "data-studio-ubb": "static-1.2307",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.26614",
  "collaboration-sidebar": "static-1.57329",
  "content-management-data-lib": "static-1.5208",
  "copilot-plugins": "static-1.10700",
  "cta-picker": "static-1.36024",
  "customer-agent-discovery-components-lib": "static-1.2639",
  "editor-components": "static-1.13035",
  "editor-iframe-lib": "static-1.8215",
  "error-messaging-js": "static-1.5061",
  "FireAlarmUi": "static-1.4401",
  "FormsCommonComponents": "static-1.85468",
  "pictos": "static-7.181",
  "react-transition-group": "static-2.62",
  "redux-request-state": "static-1.10517",
  "SharedLegalStrings": "static-1.1623",
  "smart-content-core": "static-1.42047",
  "smart-content-lib": "static-1.42700",
  "social-composer-lib": "static-1.58426",
  "structured-content-lib": "static-1.24805",
  "theme-previewer-lib": "static-1.52875",
  "tinymce-copilot": "static-1.16018",
  "xray-recommendation-lib": "static-1.7694",
  "automation-ui-routing": "static-1.20709",
  "sql-reporting-client-types": "static-1.5534",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.41833",
  "campaigns-utils-lib": "static-1.3026",
  "reporting-enablement": "static-1.22344",
  "chatspot-widget-iframe": "static-1.20630",
  "collaboration-sidebar-common": "static-1.2126",
  "forms-ai-lib": "static-1.4108",
  "codemirror-dlb": "static-1.58289",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6299",
  "report-customization-components": "static-1.12723",
  "data-quality-ui-library": "static-1.12505",
  "html-to-image": "static-1.51",
  "reporting-insights-lib": "static-1.1278"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11787",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.454",
  "dashboard-client-types": "/dashboard-client-types/static-1.290",
  "data-fetching-client": "/data-fetching-client/static-1.9548",
  "foundations-components": "/foundations-components/static-1.7655",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.680",
  "foundations-theming": "/foundations-theming/static-1.4281",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.79",
  "head-dlb": "/head-dlb/static-1.4884",
  "hs-test-utils": "/hs-test-utils/static-1.7882",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9647",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11314",
  "I18n": "/I18n/static-7.1597",
  "jasmine-runner": "/jasmine-runner/static-1.6341",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11848",
  "quartz": "/quartz/static-1.6827",
  "react-dlb": "/react-dlb/static-1.74",
  "react-rhumb": "/react-rhumb/static-1.16522",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2734",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8760",
  "settings-ui-lib": "/settings-ui-lib/static-1.12394",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6875",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11017",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9416",
  "unified-auth": "/unified-auth/static-1.307",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.588",
  "usage-tracker": "/usage-tracker/static-1.7207",
  "usage-tracker-core": "/usage-tracker-core/static-1.7057",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7952",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6090",
  "integrations-lib": "/integrations-lib/static-1.15643",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19162",
  "property-management-iframe": "/property-management-iframe/static-1.12654",
  "quartz-config": "/quartz-config/static-1.605",
  "quartz-core": "/quartz-core/static-1.6046",
  "quartz-routing": "/quartz-routing/static-1.257",
  "quick-fetch": "/quick-fetch/static-1.3805",
  "react": "/react/static-7.182",
  "rpc-client-utils": "/rpc-client-utils/static-1.4515",
  "ts-schema": "/ts-schema/static-1.3972",
  "ui-universal-auth": "/ui-universal-auth/static-1.8793",
  "UIComponents": "/UIComponents/static-3.8261",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.416",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
  "PortalIdParser": "/PortalIdParser/static-2.377",
  "raven": "/raven/static-3.5768",
  "raven-hubspot": "/raven-hubspot/static-1.6075",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3297",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3104",
  "quartz-webpack": "/quartz-webpack/static-1.3051",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3924",
  "floating-ui": "/floating-ui/static-1.53",
  "foundations-assets": "/foundations-assets/static-1.4711",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1997",
  "framer-motion": "/framer-motion/static-1.69",
  "hs-story-utils": "/hs-story-utils/static-1.9298",
  "react-aria": "/react-aria/static-1.63",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5240",
  "react-virtualized": "/react-virtualized/static-2.96",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "tanstack-table": "/tanstack-table/static-1.52",
  "trellis-assets": "/trellis-assets/static-1.1412",
  "ui-fonts": "/ui-fonts/static-1.576",
  "ui-images": "/ui-images/static-2.1122",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2764",
  "foundations-theming-base": "/foundations-theming-base/static-1.3266",
  "stylex": "/stylex/static-1.29",
  "HeadJS": "/HeadJS/static-2.731",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2993",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.149",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.218",
  "moment-timezone": "/moment-timezone/static-5.80",
  "jasmine": "/jasmine/static-4.4197",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8565",
  "ai-rendering-library": "/ai-rendering-library/static-1.9548",
  "chirp-fetch": "/chirp-fetch/static-1.1753",
  "connections-embed-lib": "/connections-embed-lib/static-1.734",
  "copilot-toolkit": "/copilot-toolkit/static-1.10727",
  "laboratory-lib": "/laboratory-lib/static-3.7031",
  "marketplace-embed": "/marketplace-embed/static-1.21663",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9058",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19118",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13333",
  "sanitize-text": "/sanitize-text/static-1.8016",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8567",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5621",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4893",
  "wootric-nps": "/wootric-nps/static-1.6854",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4522",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4025",
  "highcharts": "/highcharts/static-8.101",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2413",
  "reporting-data": "/reporting-data/static-1.66827",
  "cssUtils": "/cssUtils/static-1.762",
  "flux-actions": "/flux-actions/static-1.323",
  "HubStyle": "/HubStyle/static-2.11622",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10082",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10245",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7197",
  "icons": "/icons/static-2.636",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17695",
  "storybook-react": "/storybook-react/static-1.30",
  "trellis-story-utils": "/trellis-story-utils/static-1.4391",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5138",
  "quartz-i18n": "/quartz-i18n/static-1.502",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3602",
  "customer-data-objects": "/customer-data-objects/static-1.7525",
  "property-translator": "/property-translator/static-1.5279",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7795",
  "hs-promise-utils": "/hs-promise-utils/static-1.5466",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4750",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13058",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5462",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7658",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4345",
  "superstore": "/superstore/static-1.4640",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10017",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7663",
  "hub-http-janus": "/hub-http-janus/static-1.815",
  "hubspotter-http": "/hubspotter-http/static-1.4545",
  "immutable-less": "/immutable-less/static-1.4524",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16569",
  "nav-meta": "/nav-meta/static-1.29153",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10113",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17768",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3738",
  "property-management-common": "/property-management-common/static-1.4942",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8918",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.505",
  "module-federation": "/module-federation/static-1.20",
  "quartz-auth": "/quartz-auth/static-1.502",
  "quartz-head": "/quartz-head/static-1.492",
  "quartz-test": "/quartz-test/static-1.502",
  "quartz-tracking": "/quartz-tracking/static-1.206",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.3025",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20638",
  "ContentUtils": "/ContentUtils/static-1.67843",
  "sassPrefix": "/sassPrefix/static-1.153",
  "avatar-components": "/avatar-components/static-1.2364",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39164",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12884",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13019",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13815",
  "ExportDialog": "/ExportDialog/static-6.10260",
  "highlight.js": "/highlight.js/static-1.76",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40849",
  "reporting-snowflake": "/reporting-snowflake/static-1.55445",
  "reporting-ui-components": "/reporting-ui-components/static-2.64098",
  "reporting-visualizations": "/reporting-visualizations/static-1.58903",
  "ui-addon-teams": "/ui-addon-teams/static-1.21345",
  "magpie-lib": "/magpie-lib/static-1.5465",
  "magpie-types": "/magpie-types/static-1.4925",
  "simple-logging-lib": "/simple-logging-lib/static-1.2921",
  "navigation-components": "/navigation-components/static-1.17516",
  "ai-studio-lib": "/ai-studio-lib/static-1.11195",
  "app-governance-lib": "/app-governance-lib/static-1.1100",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10373",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7861",
  "ui-product-approvals": "/ui-product-approvals/static-1.27696",
  "ui-tool-access": "/ui-tool-access/static-1.10016",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8210",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5624",
  "usage-tracker-public": "/usage-tracker-public/static-1.7018",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.57",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3484",
  "persist-promise": "/persist-promise/static-1.3580",
  "reference-resolvers": "/reference-resolvers/static-1.8036",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3812",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.209",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2872",
  "final-form": "/final-form/static-1.67",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2377",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "atom": "/atom/static-1.4941",
  "purchase-motions-components": "/purchase-motions-components/static-1.5605",
  "salesImages": "/salesImages/static-1.522",
  "batch-promise": "/batch-promise/static-1.1423",
  "crm-component-utils": "/crm-component-utils/static-1.38663",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5744",
  "customer-data-properties": "/customer-data-properties/static-1.51016",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6745",
  "property-value-citations": "/property-value-citations/static-1.1630",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7956",
  "navigation-messaging": "/navigation-messaging/static-1.6843",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9645",
  "cms-field-types": "/cms-field-types/static-1.4680",
  "content-icons-ui": "/content-icons-ui/static-1.2186",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7120",
  "crm-message-bus": "/crm-message-bus/static-1.42581",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21599",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9695",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4592",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3900",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6650",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.848",
  "onboarding-tours": "/onboarding-tours/static-1.16365",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13263",
  "academy-common-lib": "/academy-common-lib/static-1.13275",
  "content-assistance-lib": "/content-assistance-lib/static-1.7548",
  "dashboard-lib": "/dashboard-lib/static-1.80924",
  "file-manager-components": "/file-manager-components/static-1.23140",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18081",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17812",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17804",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19596",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8564",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4639",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10813",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8904",
  "user-context": "/user-context/static-1.4971",
  "growth-payments-core": "/growth-payments-core/static-1.24929",
  "reporting-plugins": "/reporting-plugins/static-1.10069",
  "reporting-reports": "/reporting-reports/static-1.66505",
  "idb-keyval": "/idb-keyval/static-1.41",
  "reactive-lib": "/reactive-lib/static-1.595",
  "codemirror": "/codemirror/static-5.92",
  "feedback-loader": "/feedback-loader/static-1.29017",
  "react-codemirror": "/react-codemirror/static-1.10497",
  "framework-listing-lib": "/framework-listing-lib/static-2.28240",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30304",
  "apps-service-types": "/apps-service-types/static-1.3748",
  "oauth-service-types": "/oauth-service-types/static-1.4118",
  "onboarding-scopes": "/onboarding-scopes/static-1.6334",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4579",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7559",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14679",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3509",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8784",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4370",
  "nav-client-types": "/nav-client-types/static-1.2228",
  "purchase-motions-api": "/purchase-motions-api/static-1.5608",
  "signup-constants": "/signup-constants/static-1.18556",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7906",
  "trials-service-types": "/trials-service-types/static-1.3771",
  "card-properties-lib": "/card-properties-lib/static-1.43728",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36664",
  "crm-actions": "/crm-actions/static-1.6181",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43135",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8974",
  "customer-data-tracking": "/customer-data-tracking/static-1.6754",
  "hs-entities": "/hs-entities/static-1.558",
  "pulse": "/pulse/static-1.397",
  "calling-global-api": "/calling-global-api/static-1.63950",
  "calling-internal-common": "/calling-internal-common/static-1.31171",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65332",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57626",
  "commerce-products-lib": "/commerce-products-lib/static-1.9042",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3690",
  "crm-links": "/crm-links/static-1.6141",
  "external-options-client-types": "/external-options-client-types/static-1.4051",
  "google-libphonenumber": "/google-libphonenumber/static-1.35",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4115",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.502",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3582",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48246",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3856",
  "smart-property-lib": "/smart-property-lib/static-1.6229",
  "tiered-pricing": "/tiered-pricing/static-1.942",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10864",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4034",
  "react-dnd-compat": "/react-dnd-compat/static-1.4491",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5231",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2943",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1487",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.431",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7398",
  "academy-service-client": "/academy-service-client/static-1.3551",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28134",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8255",
  "video-components-external": "/video-components-external/static-1.10803",
  "video-data-lib": "/video-data-lib/static-1.34461",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8429",
  "payment-link-components": "/payment-link-components/static-1.23127",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9758",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24046",
  "viral-links-lib": "/viral-links-lib/static-1.6911",
  "data-token-picker": "/data-token-picker/static-1.16168",
  "FileManagerLib": "/FileManagerLib/static-1.38780",
  "react-flip-move": "/react-flip-move/static-1.67",
  "timezone-utils": "/timezone-utils/static-2.5115",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17199",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8497",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7193",
  "customer-data-views-management": "/customer-data-views-management/static-1.25135",
  "framework-data-table": "/framework-data-table/static-2.11593",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6717",
  "nudge-client-utils": "/nudge-client-utils/static-1.2293",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.796",
  "app-users-service-client": "/app-users-service-client/static-1.5416",
  "app-users-service-types": "/app-users-service-types/static-1.4824",
  "mini-checkout-client": "/mini-checkout-client/static-1.26489",
  "onboarding-utils": "/onboarding-utils/static-1.5223",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.1975",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28119",
  "edison-service-client-types": "/edison-service-client-types/static-1.263",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3052",
  "crm_data": "/crm_data/static-4.91485",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45610",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15347",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18687",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18147",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9986",
  "crm-fe-perf": "/crm-fe-perf/static-1.22775",
  "directed-graph": "/directed-graph/static-1.810",
  "event-emitter": "/event-emitter/static-1.818",
  "fast-json-patch": "/fast-json-patch/static-1.60",
  "calling-error-reporting": "/calling-error-reporting/static-1.31177",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10910",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6412",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.455",
  "commerce-permissions": "/commerce-permissions/static-1.635",
  "products-iframe-lib": "/products-iframe-lib/static-1.7530",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10029",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5421",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9730",
  "policy-lib": "/policy-lib/static-1.6650",
  "react-tinymce": "/react-tinymce/static-1.54824",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9793",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53950",
  "tinymce-plugins": "/tinymce-plugins/static-1.57064",
  "tinymce-themes": "/tinymce-themes/static-1.55920",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1515",
  "user-context-client": "/user-context-client/static-1.4484",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6452",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11741",
  "content-media-compositions": "/content-media-compositions/static-2.15748",
  "media-bridge-lib": "/media-bridge-lib/static-1.18690",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5835",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4957",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3539",
  "draft-convert": "/draft-convert/static-2.70",
  "draft-extend": "/draft-extend/static-3.72",
  "draft-js": "/draft-js/static-5.75",
  "draft-plugins": "/draft-plugins/static-2.21434",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3714",
  "audio-components": "/audio-components/static-1.5711",
  "FileManagerCore": "/FileManagerCore/static-1.38639",
  "FileManagerImages": "/FileManagerImages/static-1.36291",
  "video-components": "/video-components/static-1.12806",
  "crm-export-dialog": "/crm-export-dialog/static-1.6165",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6306",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1512",
  "tanstack-virtual": "/tanstack-virtual/static-1.27",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2050",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2369",
  "whisper-core-api": "/whisper-core-api/static-1.6187",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14414",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5217",
  "settings-content-modals": "/settings-content-modals/static-1.45663",
  "crm_universal": "/crm_universal/static-1.21770",
  "customer-data-email": "/customer-data-email/static-1.17795",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36715",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39087",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11461",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54252",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21057",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17326",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71437",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5202",
  "utility-belt": "/utility-belt/static-1.2411",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22213",
  "customer-data-rte": "/customer-data-rte/static-1.32623",
  "cv-backend-services": "/cv-backend-services/static-1.1528",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5470",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4985",
  "qrcode-generator": "/qrcode-generator/static-1.66",
  "quotes-client-types": "/quotes-client-types/static-1.37527",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35232",
  "sales-views-client-types": "/sales-views-client-types/static-1.4135",
  "hub-http-contrib": "/hub-http-contrib/static-1.2914",
  "interframe": "/interframe/static-3.4633",
  "tinymce-data": "/tinymce-data/static-1.40035",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5084",
  "layout-dnd-components": "/layout-dnd-components/static-1.12181",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11156",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14408",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8961",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4403",
  "video-embed": "/video-embed/static-1.35295",
  "social-insights-client-types": "/social-insights-client-types/static-1.21606",
  "deal-intel-utils": "/deal-intel-utils/static-1.1516",
  "checkout-sdk": "/checkout-sdk/static-3.23332",
  "checkout-service-types": "/checkout-service-types/static-1.3718",
  "company-details-components": "/company-details-components/static-1.6057",
  "payment-method-components": "/payment-method-components/static-1.6765",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.13012",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3355",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3397",
  "access-control-lib": "/access-control-lib/static-1.10309",
  "EmailComponents": "/EmailComponents/static-1.54341",
  "EmailData": "/EmailData/static-1.53018",
  "redux-less": "/redux-less/static-2.9357",
  "sequences-lib": "/sequences-lib/static-1.7807",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10219",
  "products-ui-components": "/products-ui-components/static-1.39561",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80158",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6846",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54268",
  "commerce-products-api": "/commerce-products-api/static-1.2067",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56326",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102115",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7265",
  "draft-content-plugins": "/draft-content-plugins/static-1.27891",
  "ContentData": "/ContentData/static-1.67918",
  "layout-data-lib": "/layout-data-lib/static-1.9481",
  "outpost": "/outpost/static-1.4069",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.781",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3800",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.3860",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18333",
  "pricing-pages-api": "/pricing-pages-api/static-1.12877",
  "ContentComponents": "/ContentComponents/static-2.70799",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.9370",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1820",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.45824",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.686",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18434",
  "automation-ui-types": "/automation-ui-types/static-1.19352",
  "messaging-types-lib": "/messaging-types-lib/static-1.45561",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4376",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7664",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.389",
  "property-description-translator": "/property-description-translator/static-1.3725",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3527",
  "totals-ui-components": "/totals-ui-components/static-1.23180",
  "stripe-connect-js": "/stripe-connect-js/static-1.65",
  "advanced-menus-core": "/advanced-menus-core/static-1.14917",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11885",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33643",
  "demographics-service-types": "/demographics-service-types/static-1.1520",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5268",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7211",
  "data-token-views": "/data-token-views/static-1.16149",
  "forms-utils-lib": "/forms-utils-lib/static-1.12311",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.12749",
  "simple-menus-core": "/simple-menus-core/static-1.14916",
  "simple-menus-lib": "/simple-menus-lib/static-1.16433",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4125",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6628",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3399",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2544",
  "ContentEditorUI": "/ContentEditorUI/static-2.76730",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3867",
  "web-interactives-components": "/web-interactives-components/static-1.13525",
  "web-interactives-data": "/web-interactives-data/static-1.13526",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.135",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.305",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.847",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3708",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21288",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.20751",
  "data-studio-ubb": "/data-studio-ubb/static-1.2307",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.26614",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57329",
  "content-management-data-lib": "/content-management-data-lib/static-1.5208",
  "copilot-plugins": "/copilot-plugins/static-1.10700",
  "cta-picker": "/cta-picker/static-1.36024",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.2639",
  "editor-components": "/editor-components/static-1.13035",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8215",
  "error-messaging-js": "/error-messaging-js/static-1.5061",
  "FireAlarmUi": "/FireAlarmUi/static-1.4401",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85468",
  "pictos": "/pictos/static-7.181",
  "react-transition-group": "/react-transition-group/static-2.62",
  "redux-request-state": "/redux-request-state/static-1.10517",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1623",
  "smart-content-core": "/smart-content-core/static-1.42047",
  "smart-content-lib": "/smart-content-lib/static-1.42700",
  "social-composer-lib": "/social-composer-lib/static-1.58426",
  "structured-content-lib": "/structured-content-lib/static-1.24805",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.52875",
  "tinymce-copilot": "/tinymce-copilot/static-1.16018",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7694",
  "automation-ui-routing": "/automation-ui-routing/static-1.20709",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5534",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.41833",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3026",
  "reporting-enablement": "/reporting-enablement/static-1.22344",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.20630",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2126",
  "forms-ai-lib": "/forms-ai-lib/static-1.4108",
  "codemirror-dlb": "/codemirror-dlb/static-1.58289",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6299",
  "report-customization-components": "/report-customization-components/static-1.12723",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12505",
  "html-to-image": "/html-to-image/static-1.51",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1278"
}
};
